<style scoped>
  div {
    /*border: white 1px solid;*/
  }
  #portfoliogrid {
    display: grid;
    grid-template-areas:
      "assetschart valuechart"
      "assets assets";
    grid-gap: 10px;
    grid-template-columns: minmax(270px, 20%) 1fr;
  }

  @media all and (max-width: 1000px) {
    #portfoliogrid {
      grid-template-areas:
        "assetschart"
        "valuechart"
        "assets";
      grid-template-columns: 1fr;
    }
  }

  #assetschart {
    grid-area: assetschart;
  }
  #valuechart {
    grid-area: valuechart;
    align-items: center;
  }
  #assets {
    grid-area: assets;
    align-items: center;
  }
</style>

<template>
  <div id="portfoliogrid">
    <AssetsChart id="assetschart"/>
    <ValueChart id="valuechart"/>
    <Assets id="assets"/>
  </div>
</template>

<script>
import Assets from './Assets'
import ValueChart from './ValueChart'
import AssetsChart from './AssetsChart'

export default {
  name: 'Portfolio',
  components: {
    ValueChart,
    Assets,
    AssetsChart
  }
}
</script>
